module.exports = __webpack_public_path__ + "static/media/salesforce_logo.3b5db11b.png";